import { Edit3, Eye, EyeOff, Plus } from "lucide-react";
import { SearchBar } from "./SearchBar";

type TopBarProps = {
  query: string;
  onQueryChange: (query: string) => void;
  onAdd: () => void;
  chromeHidden: boolean;
  onToggleChrome: () => void;
};

export function TopBar({ query, onQueryChange, onAdd, chromeHidden, onToggleChrome }: TopBarProps) {
  return (
    <header className="topbar">
      <div className="brand">
        <span className="brand-mark" aria-hidden="true" />
        <strong>lab.fcm.plus</strong>
      </div>
      <SearchBar value={query} onChange={onQueryChange} />
      <div className="topbar-actions">
        <button
          type="button"
          className="round-button"
          onClick={onToggleChrome}
          aria-label={chromeHidden ? "アイコン類を表示" : "背景だけ表示"}
          data-testid="overlay-toggle"
        >
          {chromeHidden ? <Eye /> : <EyeOff />}
        </button>
        <button type="button" className="round-button" onClick={onAdd} aria-label="URLを追加">
          <Plus />
        </button>
        <button type="button" className="round-button" onClick={onAdd} aria-label="URLを編集">
          <Edit3 />
        </button>
        <div className="avatar" aria-label="masatomo">
          M<span />
        </div>
      </div>
    </header>
  );
}
